import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/src/app/global-error.tsx");
